import React from 'react';
import useToggleStuckClassRef from 'hooks/useToggleStuckClassRef';
import {
  RichTextEditorControls,
  RichTextEditorControlsLoader,
  RichTextEditorControlsWrapper,
} from '../RichTextEditor.styles';
import { RichTextEditorControlsPluginProps } from '../RichTextEditor.types';
import Loader from '../../loader/Loader';
import ControlsPluginButtons from './ControlsPluginButtons';
import ControlsPluginAttachments from './ControlsPluginAttachments';
import ControlsPluginSuggestAnswer from './ControlsPluginSuggestAnswer';

const ControlsPlugin = ({
  controlsSettings: {
    attachmentsAvailable,
    attachmentIconDisabled,
    enableStickyControls,
    suggestAnswerAvailable,
    buttons,
    buttonsSwitcher,
    customIcons,
    isLoading,
    onAttachmentSelected,
    chatHistory,
    setSuggestion,
    suggestionButtonDisabled,
    globalContext,
    suggestionButtonLoading,
    getSuggestions,
    activeLead,
  },
}: RichTextEditorControlsPluginProps) => {
  const toggleStuckClassRef = useToggleStuckClassRef({
    enabled: enableStickyControls ?? false,
    direction: 'bottom',
  });

  if (isLoading) {
    return (
      <RichTextEditorControls>
        <Loader inline />
      </RichTextEditorControls>
    );
  }

  return (
    <RichTextEditorControlsWrapper
      $isSticky={enableStickyControls}
      ref={toggleStuckClassRef}
    >
      {suggestionButtonLoading && (
        <RichTextEditorControlsLoader>
          <Loader inline />
        </RichTextEditorControlsLoader>
      )}

      <RichTextEditorControls>
        {customIcons?.map(({ iconElement, id }) => (
          <React.Fragment key={id}>{iconElement}</React.Fragment>
        ))}
        {attachmentsAvailable && (
          <ControlsPluginAttachments
            // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
            disabled={attachmentIconDisabled}
            // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
            onAttachmentSelected={onAttachmentSelected}
          />
        )}
        {suggestAnswerAvailable && (
          <ControlsPluginSuggestAnswer
            // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
            suggestionButtonDisabled={suggestionButtonDisabled}
            // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
            globalContext={globalContext}
            // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
            suggestionButtonLoading={suggestionButtonLoading}
            // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
            getSuggestions={getSuggestions}
            // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
            chatHistory={chatHistory}
            // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
            setSuggestion={setSuggestion}
            // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
            activeLead={activeLead}
          />
        )}
        <ControlsPluginButtons
          buttons={buttons}
          buttonsSwitcher={buttonsSwitcher}
        />
      </RichTextEditorControls>
    </RichTextEditorControlsWrapper>
  );
};

export default ControlsPlugin;
